import { ReactNode, createContext, useState } from 'react';

interface BackButtonState {
  label?: string;
  action: (() => void) | null;
}

interface AppState {
  backButton: BackButtonState;
  setBackButton: (state: BackButtonState) => void;
}

export const AppContext = createContext<AppState | undefined>(undefined);

const AppProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [backButton, setBackButton] = useState<BackButtonState>({ label: undefined, action: null });

  return (
    <AppContext.Provider value={{ backButton, setBackButton }}>{children}</AppContext.Provider>
  );
};

export default AppProvider;
